// Build <CustomSelect> options from the GetStore API storeInfo list.
export const buildStoreOptions = (storeInfo) =>
  (storeInfo || []).map((store) => ({ label: store.storeName, value: store.storeId }));

// Normalize a store id from the <select> (a string) into the numeric form the
// downstream PricingContract strict-equality comparisons expect. Blank stays ''.
export const normalizeStoreId = (raw) =>
  raw === "" || raw === null || raw === undefined ? "" : Number(raw);

// The AddGrpContact step requires a contract name, a salesperson and a store.
export const isAddGrpContactStepValid = ({ contractName, salesPersonId, storeId }) =>
  contractName !== "" && salesPersonId !== "" && storeId !== "";
